
<br>
<div class="col-md-11">

  <p class="reportlabel">
    Rapport: Medlemsantal - eget valt datum<i *ngIf="showSpinner" class="fa fa-spinner fa-spin" style="font-size:22px;color:#920000;margin-left:30px;"></i></p>
    <hr />
</div>

<div style="min-width: 400px;">
<form [formGroup]="form" class="ms-4">

  <div class="d-flex justify-content-start align-items-center gap-2">
  <div class="form-group">
    <label for="breakDate">
      Ange brytdatum
    </label>
    <!--input type="text" class="form-control form-control-sm cap" id="birthDateFrom" [textMask]="{mask: maskdatum, pipe: autoCorrectedDatePipe}"
      formControlName="birthDateFrom"-->
      <app-calendarnotrequired [form]="form" formName="breakDate"></app-calendarnotrequired>
  </div>
  <div class="form-group ms-2"><label>&nbsp;</label><button class="btn btn-sm" (click)="search()">Skapa rapport</button></div>
</div>

</form>
</div>
<br>
<div *ngIf="charginglist?.length>0" class="col-md-6 ms-4">
  <p-menubar [model]="items">
    Antalet medlemmar i respektive institution {{form.get('breakDate').value | date: 'yyyy-MM-dd'}}
    <div style="margin-top:5px;margin-right:10px;">
      Resultat: {{charginglist?.length}}
    </div>
  </p-menubar>

<div *ngIf="charginglist?.length > 0" class="mt-2 border">

  <div class="ms-2" id="contentToConvert">
    <div class="row" style="font-weight:bold;">
      <div class="col-md-1">Typ</div>
      <div class="col-md-2">Nummer</div>
      <div class="col-md-4">Namn</div>
      <div class="col-md-3">Antal medlemmar</div>
    </div>
    <div *ngFor="let c of charginglist; let i = index">
      <div class="row" style="border-bottom:1px solid #F2F2F2;">
        <div class="col-md-1">{{c.type}}</div>
        <div class="col-md-2">{{c.institutionNumber}}</div>
        <div class="col-md-4">{{c.name}}</div>
        <div class="col-md-3">{{c.noOfMembers}}</div>
      </div>
    </div>
  </div>
</div>
</div>


